export const COMPLETED_STATUS_VALUE = 'Completed';
export const APPROVED_STATUS_VALUE = 'Approved';

export interface RequestStatusRow {
  request_status: string;
  request_count: number;
}

/**
 * Folds "Completed" request rows into "Approved" (used when the
 * advanced-requests-completed-status flag is off). Rows whose request_status is
 * "Completed" are relabeled to "Approved" and merged (request_count summed) with
 * rows sharing the same groupKeys + status. Non-count fields are taken from the
 * first row of each merged group. Pure — never mutates its input.
 */
export function foldCompletedIntoApproved<T extends RequestStatusRow>(
  rows: T[],
  groupKeys: (keyof T)[] = []
): T[] {
  const merged = new Map<string, T>();

  rows.forEach((row) => {
    const status =
      row.request_status === COMPLETED_STATUS_VALUE
        ? APPROVED_STATUS_VALUE
        : row.request_status;
    const key = [...groupKeys.map((k) => String(row[k])), status].join('|');
    const existing = merged.get(key);

    if (existing) {
      merged.set(key, {
        ...existing,
        request_count: existing.request_count + row.request_count,
      });
    } else {
      merged.set(key, { ...row, request_status: status });
    }
  });

  return Array.from(merged.values());
}
